import type { NavItem } from '../types';

/**
 * Navigation items for HR module sidebar
 *
 * Organized around HR jobs-to-be-done, in the order HR actually works:
 * - Dashboard: overview, health checks, to-dos — the landing page
 * - Employees: the core directory + detail pages, the canonical people record
 * - Org: org chart and seat management
 * - Compliance: policies, notices, audit trail, agent monitoring
 * - Hiring: offers, onboarding, templates
 *
 * There is deliberately no "Hiring" group. HR owns current and former
 * employees; candidates, jobs, applications and interviews all live in the
 * Recruiting module, which is where hiring actually happens.
 *
 * Onboarding and its templates stay here despite once sitting under
 * "Hiring" — both are post-hire employee workflows (equipment, accounts,
 * paperwork for someone who has already joined), so the old grouping was
 * simply mislabelled. The Offers page that WAS pre-hire is gone; /hr/offers
 * redirects to the Recruiting pipeline.
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/hr', icon: 'LayoutDashboard' },
  { label: 'Employees', path: '/hr/employees', icon: 'Users' },
  { label: 'Org', path: '/hr/org-chart', icon: 'Network' },
  {
    label: 'Compliance',
    path: '/hr/policies',
    icon: 'ShieldCheck',
    children: [
      { label: 'Policies', path: '/hr/policies' },
      { label: 'Notices', path: '/hr/notices' },
      { label: 'Audit Log', path: '/hr/audit' },
      { label: 'Agent Activity', path: '/hr/agent-activity' },
    ],
  },
  { label: 'Onboarding Templates', path: '/hr/templates', icon: 'UserPlus' },
];
